import {
  useQuery,
  useQueryClient,
  UseQueryOptions,
} from '@tanstack/react-query';
import { IdProvider, unwrap } from '../common/apiCommons';
import axios from 'axios';

export enum RecordPictureKeys {
  PICTURE = 'PICTURE',
}
interface RecordPicture {
  id: number;
  picture: string;
}

const queries = {
  async getPicturesOfNewJobRecord(record: IdProvider) {
    if (!record?.id) {
      return null;
    }
    const res = await axios.get<RecordPicture[]>(
      `/record/record_pictures/${record.id}/N/`,
    );
    return unwrap(res);
  },
  async getPicturesOfRoutines(routineRecord: IdProvider) {
    if (!routineRecord?.id) {
      return null;
    }
    const res = await axios.get<RecordPicture[]>(
      `/record/record_pictures/${routineRecord.id}/R/`,
    );
    return unwrap(res);
  },
};
const mutations = {};
const hooks = {
  usePicturesOfNewJobRecord(
    record: IdProvider,
    options?: UseQueryOptions<RecordPicture[] | null>,
  ) {
    const queryClient = useQueryClient();
    const result = useQuery({
      queryKey: [RecordPictureKeys.PICTURE, record?.id],
      queryFn: () => queries.getPicturesOfNewJobRecord(record),
      ...(options ?? {}),
    });
    const QueryResultAndInvalidate: [typeof result, () => Promise<void>] = [
      result,
      () =>
        queryClient.invalidateQueries([RecordPictureKeys.PICTURE, record?.id]),
    ];
    return QueryResultAndInvalidate;
  },
  usePicturesOfRoutineRecord(
    record: IdProvider,
    options?: UseQueryOptions<RecordPicture[] | null>,
  ) {
    return useQuery({
      queryKey: [RecordPictureKeys.PICTURE, 'new_job', record?.id],
      queryFn: () => queries.getPicturesOfRoutines(record),
      ...(options ?? {}),
    });
  },
};

const RecordPictureApi = {
  queries,
  mutations,
  hooks,
};

export default RecordPictureApi;
